import React from "react";
import { Session, SessionStatuses } from "../../data/Session";

export interface SessionListProps {
  list: Session[];
  currentSessionId: string;
  settingCurrentId: string;
  onEdit: (session: Session) => void;
  onSetCurrent: (session: Session) => void;
}

export function sessionStatusChipClass(status: string): string {
  switch (status) {
    case SessionStatuses.InSession:
      return "sl-chip-status-new";
    case SessionStatuses.Voting:
      return "sl-chip-status-voting";
    case SessionStatuses.Completed:
      return "sl-chip-status-voted";
    default:
      return "sl-chip-type";
  }
}

function SessionList({ list, currentSessionId, settingCurrentId, onEdit, onSetCurrent }: SessionListProps) {
  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th>ID - Name</th>
            <th>Status</th>
            <th>Participant View / Buttons</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {list.map((session) => {
            const isCurrent = session.subId === currentSessionId;
            return (
              <tr key={session.subId} className={isCurrent ? "sl-row-current" : undefined}>
                <td>
                  <span className="sl-num">{session.subId}</span> - {session.name}
                  {isCurrent ? <span className="sl-chip sl-chip-current ms-2">Current</span> : null}
                </td>
                <td>
                  <span className={`sl-chip ${sessionStatusChipClass(session.status)}`}>{session.status}</span>
                </td>
                <td>
                  {session.enableParticipantView ? "Yes" : "No"} / {session.enableParticipantButtons ? "Yes" : "No"}
                </td>
                <td className="text-nowrap">
                  <button className="btn btn-light btn-sm" onClick={() => onEdit(session)}>
                    Edit
                  </button>
                  {isCurrent ? null : (
                    <button className="btn btn-outline-primary btn-sm ms-2" disabled={settingCurrentId !== ""} onClick={() => onSetCurrent(session)}>
                      {settingCurrentId === session.subId ? "Setting..." : "Set as current"}
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
          {list.length === 0 ? (
            <tr>
              <td colSpan={4} className="text-muted">
                No Sessions found
              </td>
            </tr>
          ) : (
            <></>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default SessionList;
